// function addAllToCart() {
//   const addToCartData = document.getElementById('add-to-cart-data');
//   if (!addToCartData) {
//     console.error('Add to cart data element not found');
//     return;
//   }
//   const mainProductVariantId = addToCartData.getAttribute('data-main-product-id');
//   const isMainProductAvailable = addToCartData.getAttribute('data-main-product-available') === 'true'; 

//   const metafieldsProductsAttr = addToCartData.getAttribute('data-metafield-products');
//   const cartItems = [];
//   const cartDrawer = document.querySelector('cart-drawer');   

//   if (mainProductVariantId && isMainProductAvailable) {
//     cartItems.push({
//       id: mainProductVariantId,
//       quantity: 1,
//     });
//   }

//   if (metafieldsProductsAttr) {
//     try {
//       const metafieldsProducts = JSON.parse(metafieldsProductsAttr);
//       metafieldsProducts.forEach((product) => {
//         if (product && product.id) {
//           cartItems.push({
//             id: product.id,
//             quantity: 1,
//           });
//         }
//       });
//     } catch (error) {
//       console.error('Error parsing metafield products:', error);
//     }
//   }

//   if (cartItems.length === 0) {
//     console.error('No items to add to cart');
//     return;
//   }

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify({ items: cartItems }),
//   })
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       return response.json();
//     })
//     .then((data) => {
//       cartDrawer.classList.remove('is-empty');      
//       fetch(`${routes.cart_url}?section_id=cart-drawer`)
//       .then((response) => response.text())
//       .then((responseText) => {
//         const html = new DOMParser().parseFromString(responseText, 'text/html');
//         const selectors = ['#CartDrawer' ];
//         for (const selector of selectors) {
//           const targetElement = document.querySelector(selector);
//           const sourceElement = html.querySelector(selector);
//           if (targetElement && sourceElement) {
//             targetElement.replaceWith(sourceElement);
//           }
//         }
//       })
//       fetch(`${routes.cart_url}?section_id=header`)
//         .then((response) => response.text())
//         .then((responseText) => {
//             const html = new DOMParser().parseFromString(responseText, 'text/html');
//             const targetElement = document.querySelector('#cart-icon-bubble');
//             const sourceElement = html.querySelector('#cart-icon-bubble');
//             if (targetElement && sourceElement) {
//                 targetElement.replaceWith(sourceElement);
//             }
//         })
//       cartDrawer.classList.add('active');
//        closeDrawer();
//     })
//     .catch((error) => {
//       console.error('Error adding to cart:', error);
//       alert('Unable to add items to cart. Please try again.');
//     });
// }

// document.getElementById('add-all-to-cart').addEventListener('click', function() {
//   addAllToCart();
// });
 
// function closeDrawer() {
//   const cartDrawer = document.querySelector('cart-drawer');
// document.getElementById('CartDrawer-Overlay').addEventListener('click', function() {
//   console.log("ninee....");
//         cartDrawer.classList.remove('active');
//       });
// }

class CartHandler {
  constructor() {
    this.cartDrawer = document.querySelector('cart-drawer');
    this.cartDrawerBody = document.querySelector('body');
    this.cartDrawerOverlay = document.querySelector('#CartDrawer-Overlay');
    this.addToCartData = document.getElementById('add-to-cart-data');
    this.addAllToCartButton = document.getElementById('add-all-to-cart');
    this.isDrawerOpen = false;

    this.init();
  }
  init() {
    if (!this.cartDrawer || !this.addToCartData || !this.addAllToCartButton) {
      console.error('Essential DOM elements are missing.');
      return;
    }
    this.addAllToCartButton.addEventListener('click', () => this.openDrawer());
    this.cartDrawerOverlay.addEventListener('click', () => this.closeDrawer());
  }
  openDrawer() {
    if (this.cartDrawer) {
      this.cartDrawer.classList.add('active');
      this.isDrawerOpen = true;
    }
  }
  closeDrawer() {
    if (this.cartDrawer) {
      this.cartDrawer.classList.remove('active');
      this.isDrawerOpen = false;
    }
  }
  addAllToCart() {
    const addToCartData = document.getElementById('add-to-cart-data');
    if (!addToCartData) {
      console.error('Add to cart data element not found');
      return;
    }
    const mainProductVariantId = addToCartData.getAttribute('data-main-product-id');
    const isMainProductAvailable = addToCartData.getAttribute('data-main-product-available') === 'true';

    const metafieldsProductsAttr = addToCartData.getAttribute('data-metafield-products');
    const cartItems = [];

    if (mainProductVariantId && isMainProductAvailable) {
      cartItems.push({
        id: mainProductVariantId,
        quantity: 1,
      });
    }

    if (metafieldsProductsAttr) {
      try {
        const metafieldsProducts = JSON.parse(metafieldsProductsAttr);
        metafieldsProducts.forEach((product) => {
          if (product && product.id) {
            cartItems.push({
              id: product.id,
              quantity: 1,
            });
          }
        });
      } catch (error) {
        console.error('Error parsing metafield products:', error);
      }
    }

    if (cartItems.length === 0) {
      console.error('No items to add to cart');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: cartItems }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        this.cartDrawer.classList.remove('is-empty');
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['#CartDrawer'];
            selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              const cartDrawer = document.querySelector('cart-drawer');
              const cartDrawerBody = document.querySelector('body');
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
               document.getElementById('CartDrawer-Overlay').addEventListener('click', () => {
                cartDrawer.classList.remove('active');
                cartDrawerBody.classList.remove('overflow-hidden')
                cartDrawerBody.classList.remove('cart_draw')
              });
            });
          });
        fetch(`${routes.cart_url}?section_id=header`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
             const targetElements = document.querySelectorAll('.wbhcartitem, .wbcarthtotal span');
            const sourceElements = html.querySelectorAll('.wbhcartitem, .wbcarthtotal span');
              targetElements.forEach((targetElement, index) => {
              const sourceElement = sourceElements[index];
              if (sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
                });
          });
        this.cartDrawer.classList.add('active');
        this.cartDrawerBody.classList.add('overflow-hidden')
        this.cartDrawerBody.classList.add('cart_draw')
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        alert('Unable to add items to cart. Please try again.');
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const cartHandler = new CartHandler();
  document.getElementById('add-all-to-cart').addEventListener('click', () => {
    cartHandler.addAllToCart();
  });
  document.getElementById('CartDrawer-Overlay').addEventListener('click', () => {
    cartHandler.closeDrawer();
  });
});
